const formatDateRange = (startDate?: Date, endDate?: Date) => {
  if (!startDate || !endDate) return '';

  if (startDate.toDateString() === endDate.toDateString()) {
    return startDate.toLocaleDateString();
  }
  return `${startDate.toLocaleDateString()} – ${endDate.toLocaleDateString()}`;
};

export default formatDateRange;
